var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophicPrimaryConsumers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.023.051c-.309-.176-.64.165-.816.423 0-.082.066-.423-.276-.47-.342-.047-.76.318-1.125.905-.364.588-.573 1.917-.606 2.187-.033.27-.243.353-.53.377-.286.023-.76.211-.838.282-.077.07-1.213 1.352-1.268 1.493-.056.141-.133.365.055.73.187.364.695.587.827.622.132.036.32.165.33.377.012.211.056 1.87.188 2.504.133.635.783 1.293 1.026 1.61.243.318.21.542.155 1.07-.056.53-.398.742-.651.883-.254.14-.331.34-.342.6-.009.206.121.313.187.34.438.012 1.33.029 1.401 0 .088-.035.276-.129.452-.364.177-.235.442-1.188.574-1.646.132-.459.485-.459.573-.459.089 0 .475-.07.706.212.232.282.949.529 1.07.623l-.004.001c-.096.03-.817.25-1.165.446-.353.2-.375.8-.353 1 .018.16.177.191.254.187.878.004 2.678.01 2.845 0 .21-.011.607-.047.982-.188.366-.137 1.183-.733 1.417-.905l.017-.012c.21-.153.551-.223.915-.54.364-.318.497-1.435.475-1.459-.022-.023-.585.153-.74.33.034-.2.122-1.223-.132-2.082-.253-.858-.64-1.481-1.864-2.387-1.224-.905-3.187-.987-3.717-.964-.53.024-1.213.06-1.29-.023-.077-.083 0-.412 0-.694s-.044-.564 0-1.046c.044-.483.739-1.212 1.037-1.823.297-.611.54-1.964.231-2.14Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophicPrimaryConsumers);
export default __webpack_public_path__ + "static/media/trophic-primary-consumers.02899d6de2e5be98126de235174e733d.svg";
export { ForwardRef as ReactComponent };